// Sinhala translations
export const si: Record<string, string> = {
  'menu.dashboard': 'උපකරණ පුවරුව',
  'menu.customers': 'ගනුදෙනුකරුවන්',
  'menu.products': 'නිෂ්පාදන',
  'menu.users': 'පරිශීලකයන්',
  'menu.settings': 'සැකසුම්',
  'menu.logout': 'ඉවත් වන්න',
  'dashboard.title': 'උපකරණ පුවරුව',
  'dashboard.newOrder': 'නව ඇණවුම',
  'order.title': 'නව ඇණවුම',
  'order.customer': 'ගනුදෙනුකරු',
  'order.products': 'නිෂ්පාදන',
  'order.total': 'එකතුව',
  'users.title': 'පරිශීලකයන්',
  'users.name': 'නම',
  'users.email': 'ඊමේල්',
  'common.yes': 'ඔව්',
  'common.no': 'නැත',
  'common.cancel': 'අවලංගු කරන්න',
  'common.save': 'සුරකින්න',
  'common.search': 'සොයන්න',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'පිවිසෙන්න',
  'login.welcome': 'සාදරයෙන් පිළිගනිමු, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'ඊමේල්',
  'signup.phone': 'දුරකථනය',
  'menu.reportsAndAccounting': 'වාර්තා සහ ගිණුම්කරණය',
  'menu.systemAndCommunication': 'පද්ධතිය සහ සන්නිවේදනය',
};